import { ISliderDots } from './interfaces';
import ReactDOM from 'react-dom';
import React from 'react';
import SliderDots from './slider-dots';

const handleSliderDots = () => {
    const $sliderDots = document.querySelectorAll("[slider-dots]");
    //console.log('handleSliderDots $sliderDots: ',$sliderDots);
    if (!$sliderDots) return;


    let cnt = 1;
    var decodeHTML = function (html:any) {
        var txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    };

    $sliderDots.forEach($sliderDot  => {

        if(!$sliderDot || !$sliderDot.textContent)
            return;
        let sliderDotSources;
        try{
            sliderDotSources= JSON.parse(decodeHTML($sliderDot.innerHTML)) as ISliderDots[];
        }
        catch(ex){
            console.log('try parse $sliderDots: ',ex);
        }

        if(!sliderDotSources)
            return;

        /*Attributed start*/
        const dataHeight = $sliderDot.getAttribute("data-height");
        let dataHeightNum:number | null = null;
        if(dataHeight && dataHeight !== '')
            dataHeightNum = parseInt(dataHeight);

        const dataHeightIphone = $sliderDot.getAttribute("data-height-iphone");
        let dataHeightIphoneNum:number | null = null;
        if(dataHeightIphone && dataHeightIphone !== '')
            dataHeightIphoneNum = parseInt(dataHeightIphone);

        const dataHeightTablet = $sliderDot.getAttribute("data-height-tablet");
        let dataHeightTabletNum:number | null = null;
        if(dataHeightTablet && dataHeightTablet !== '')
            dataHeightTabletNum = parseInt(dataHeightTablet);

        const dataBG = $sliderDot.getAttribute("data-bg");
        let autoScroll = null;
        if($sliderDot.hasAttribute("auto-scroll")){
            const autoScrollAttr = $sliderDot.getAttribute("auto-scroll");
            if(autoScrollAttr)
                autoScroll = parseInt(autoScrollAttr);
            else
                autoScroll = 5000;

        }

        const dataStyle = $sliderDot.getAttribute("data-style") || 'style-1';
        /*Attributed end*/

        const $sliderDotPlaceholder = document.createElement('div');
        const elId = cnt++;
        $sliderDotPlaceholder.setAttribute("id", 'slider-dot-' + elId.toString());
        $sliderDot.after($sliderDotPlaceholder);

        ReactDOM.render(
            <React.StrictMode>
                <SliderDots
                    sliderDots={sliderDotSources}
                    cnt={elId}
                    dataHeight={dataHeightNum}
                    dataHeightIphone={dataHeightIphoneNum}
                    dataHeightTablet={dataHeightTabletNum}
                    dataBG={dataBG}
                    dataStyle={dataStyle}
                    autoScroll={autoScroll}/>
            </React.StrictMode>,
            $sliderDotPlaceholder
        );
    });

}

document.addEventListener('DOMContentLoaded', () => {
    handleSliderDots();
});
